import ModalHeader from 'src/components/Modal/header'
import ModalFooter from 'src/components/Modal/footer'
import Button from '@hotmart/space-lib/dist/components/button'
import i18n from 'src/i18n'
import { PostMediaContainer } from 'src/components/postCard/components/postMediaContainer'
import {
  CustomModal,
  CustomModalBody,
  PostModalHeader
} from 'src/pages/CommunityDetails/PostModalPublication'
import { EditPostModalContent } from '../editPostModalContent'
import { PostModalSidebarProps } from '../../editPost.types'

const EditPostModal = ({
  isOpen,
  onClose,
  title,
  showPostMediaContainer,
  setTitle,
  description,
  setDescription,
  mentions,
  submitAction,
  isLoading,
  isDisabled,
  post,
  handleModalFullScreen
}: PostModalSidebarProps) => (
  <CustomModal show={isOpen} onClose={onClose}>
    <ModalHeader className="_px-5 _py-4 _border-bottom _border-gray-200">
      <PostModalHeader handleOnClose={onClose} handleModalFullScreen={handleModalFullScreen} />
    </ModalHeader>

    <CustomModalBody
      id="post-modal"
      className="_p-0 _pt-6 _px-8 _border-bottom _border-gray-200 _overflow-x-hidden _overflow-y-hidden"
    >
      <EditPostModalContent
        title={title}
        setTitle={setTitle}
        description={description}
        postType={post.postType}
        setDescription={setDescription}
        mentions={mentions}
      />
      {showPostMediaContainer && <PostMediaContainer post={post} isEdit />}
    </CustomModalBody>

    <ModalFooter className="_p-5 _bg-gray-100">
      <div className="_w-full _d-flex _justify-content-end">
        <Button onClick={submitAction} loading={isLoading} disabled={isDisabled}>
          {i18n.t('modals.schedule_posts.buttons.save')}
        </Button>
      </div>
    </ModalFooter>
  </CustomModal>
)

export default EditPostModal
